module.exports = __webpack_public_path__ + "assets/img/101411.1dd514a4.svg";